import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { LogoutOutlined } from '@mui/icons-material';

import useStudent from 'store/student/useStudent';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
}

const MenuSettings = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth } = props;

  const { onCloseReadOnly, onUpdateSurveyType } = useSurvey();
  const { onResetStudent } = useStudent();
  const { onResetPatient } = usePatient();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  // 학생 메뉴와 교수 메뉴 변경
  const settings = [
    {
      icon: <LogoutOutlined />,
      label: 'EXIT',
    },
  ];

  const onClickListItem = (label: string) => {
    if (label === 'EXIT') {
      onResetStudent();
      onResetPatient();
      onCloseReadOnly();
      window.close();
    }
  };

  return (
    <Fragment>
      {settings.map(({ icon, label }) => {
        const onClick = () => {
          onClickListItem(label);
        };

        // 축소된 메뉴 (52px)
        if (menuDrawerWidth !== 220) {
          if (!icon) return null;

          return (
            <Tooltip
              key={label}
              title={label}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                  },
                },
                arrow: {
                  sx: {
                    color: 'rgba(0, 0, 0, 0.9)',
                  },
                },
              }}
            >
              <ListItem disablePadding>
                <ListItemButton onClick={onClick}>
                  <ListItemIcon>{icon}</ListItemIcon>
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        }

        // 확장된 메뉴 (220px)
        if (icon) {
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton onClick={onClick}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} />
              </ListItemButton>
            </ListItem>
          );
        }

        if (toggle) {
          return (
            <ListItem key={label} disablePadding>
              <ListItemButton className={''}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={label} sx={{ whiteSpace: 'pre-wrap' }} />
              </ListItemButton>
            </ListItem>
          );
        }

        return null;
      })}
    </Fragment>
  );
};

export default MenuSettings;
